import { Component, OnInit,OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LazyLoadScriptService } from './../sidebar/lazy-load-script.service'
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html'
})

export class TrainingComponent implements OnInit {

  imageoneTraining: boolean = false;
  pageTitle:string;
  pageDisplay: string;

  constructor(private activatedroute: ActivatedRoute,private router: Router,private lazyLoadService: LazyLoadScriptService) { }

  ngOnInit(): void {
    var applicationName = "trainingappelement";
    this.lazyLoadService.loadScript(environment["TRAININGAPPURL"], applicationName).subscribe(_ => {
      let url = this.router.url;
      if (url == '/training') {
        this.pageTitle = "Training";
        this.pageDisplay = "training";
      } else if(url == '/admin'){
        this.pageTitle = "Admin";
        this.pageDisplay = "adminList";
      } else if(url == '/trainingdocs'){
        this.pageTitle = "Training";
        this.pageDisplay = "trainingList";
      } else if(url == '/stats'){
        this.pageTitle = "Stats";
        this.pageDisplay = "statsList";
      } else if(url == '/divisions'){
        this.pageTitle = "User File Allocation";
        this.pageDisplay = "userFileAction";
      }

      console.info('Page Display:',this.pageDisplay);
      this.imageoneTraining = true;
    });
  }

  ngOnDestroy(): void {
    this.imageoneTraining = false;
  }

}